var map = {
	"./answer-block.png": "3ad0",
	"./answer-capacitor.png": "681f",
	"./answer-ceramic.png": "1b4c",
	"./block-blue.png": "71b0",
	"./block-green.png": "4677",
	"./block-magenta.png": "b87e",
	"./block-purple.png": "122e",
	"./block-teal.png": "fec2",
	"./block-yellow.png": "b8b2",
	"./capacitor-blue.png": "a9a4",
	"./capacitor-green.png": "1abe",
	"./capacitor-magenta.png": "8746",
	"./capacitor-purple.png": "ef8f",
	"./capacitor-teal.png": "752b",
	"./capacitor-yellow.png": "daf3",
	"./ceramic-blue.png": "354d",
	"./ceramic-green.png": "12f3",
	"./ceramic-magenta.png": "6e9a",
	"./ceramic-purple.png": "ca26",
	"./ceramic-teal.png": "8207",
	"./ceramic-yellow.png": "c605",
	"./cloud.png": "fcfa",
	"./lights.png": "b767"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cbdb";